// extracted by mini-css-extract-plugin
export default {"main":"cardinfo_main__GqqLT","imager":"cardinfo_imager__Vt6J6","name":"cardinfo_name__EIsD4","button":"cardinfo_button__czTsj"};